export const buildTime = '2026-10-08 12:47:26 UTC';
